import React from "react"
import { Link } from 'react-router-dom'

export default ({ onNav }) => {
  return <Link to={ "/" } onClick={ onNav }> Current Dodone </Link>
}
